import moment from 'moment';
import constants from "./constants.js";

const host = "ws://127.0.0.1:2693";
let onMsgReceiveEvents = [];
let onSocketClosedEvent = constants.emptyFnc;
let lastMessageData;
let lastMessageTimestamp = moment();

function init(cb) {
  console.log('qrcode init');
  const self = this;

  this.websocketCtrl = new WebSocket(host, 'ctrl');
  this.websocketData = new WebSocket(host, 'data');

  this.websocketData.onopen = function (evt) {
    console.log('reader connected');
    this.isConnected = true;

    if (cb) cb();
  };

  this.websocketData.onclose = function () {
    console.log('reader disconnected');
    this.isConnected = false;
    onSocketClosedEvent();
  };

  this.websocketData.onmessage = function (evt) {
    if (lastMessageData !== evt.data || moment().diff(lastMessageTimestamp, 'seconds') >= 3) self.websocketCtrl.send("beep1"); //Beep sound

    lastMessageData = evt.data;
    lastMessageTimestamp = moment();
    _.forEach(onMsgReceiveEvents, event => {
      event(lastMessageData);
    });
  }

  // setTimeout(()=>{
  //   _.forEach(this.onMsgReceiveEvents, event => {
  //     console.log('event:',event);
  //     event('111');
  //   });
  // },10000);

}

function lightOn() {
  this.websocketCtrl.send("lighton");
}

function lightOff() {
  this.websocketCtrl.send("lightoff");
}

function isInited() {
  return !!this.isConnected;
}

function addMsgReceiveEvent(fnc) {
  onMsgReceiveEvents.push(fnc);
}

function setSocketClosedEvent(fnc) {
  onSocketClosedEvent = fnc;
}

export { init, lightOn, lightOff, isInited, addMsgReceiveEvent, setSocketClosedEvent };


// WEBPACK FOOTER //
// client/common/qrCodeReader.js